import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Careers from './views/Career.vue'
import Working from './views/Working.vue'
import Contact from './views/Contact.vue'
import Trademarks from './components/footerContent/Trademarks.vue'
import Patents from './components/footerContent/Patents.vue'
import Terms from './components/footerContent/Terms.vue'
import Privacy from './components/footerContent/Privacy.vue'
import ResponsibleGaming from './components/footerContent/Responsible.vue'
// import Land from './views/games/Land.vue'
import SMV from './views/games/SMV.vue'
import LMS from './views/games/LMS.vue'
// import DSD from './views/games/DSD.vue'
import SocialGames from './views/games/SocialGames.vue'
import Games from './views/games/Games.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        title: 'Blitzoo'
      },
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      meta: {
        title: 'About - Blitzoo'
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    // {
    //   path: '/land-based-games',
    //   name: 'land-based',
    //   meta: {
    //     title: 'Land-Based Games - Blitzoo'
    //   },
    //   component: Land
    // },
    {
      path: '/games',
      name: 'games',
      meta: {
        title: 'Games - Blitzoo'
      },
      component: Games
    },
    {
      path: '/social-games',
      name: 'social-games',
      meta: {
        title: 'Social Games - Blitzoo'
      },
      component: SocialGames
    },
    {
      path: '/show-me-vegas-slots',
      name: 'smv',
      meta: {
        title: 'Show Me Vegas Slots - Blitzoo'
      },
      component: SMV
    },
    {
      path: '/lobstermania-slots',
      name: 'lms',
      meta: {
        title: 'Lobstermania Slots - Blitzoo'
      },
      component: LMS
    },
    // {
    //   path: '/ding-slots-ding',
    //   name: 'dsd',
    //   meta: {
    //     title: 'Ding Slots Ding! - Blitzoo'
    //   },
    //   component: DSD
    // },
    {
      path: '/careers',
      name: 'careers',
      meta: {
        title: 'Careers - Blitzoo'
      },
      component: Careers
    },
    {
      path: '/working-at-blitzoo',
      name: 'working',
      meta: {
        title: 'Working at Blitzoo - Blitzoo'
      },
      component: Working
    },
    {
      path: '/contact',
      name: 'contact',
      meta: {
        title: 'Contact - Blitzoo'
      },
      component: Contact
    },
    {
      path: '/trademarks',
      name: 'trademarks',
      meta: {
        title: 'Trademarks - Blitzoo'
      },
      component: Trademarks
    },
    {
      path: '/patents',
      name: 'patents',
      meta: {
        title: 'Patents - Blitzoo'
      },
      component: Patents
    },
    {
      path: '/terms',
      name: 'Terms',
      meta: {
        title: 'Terms of Use - Blitzoo'
      },
      component: Terms
    },
    {
      path: '/privacy',
      name: 'Privacy',
      meta: {
        title: 'Privacy Policy - Blitzoo'
      },
      component: Privacy
    },
    {
      path: '/responsiblegaming',
      name: 'ResponsibleGaming',
      meta: {
        title: 'Responsible Gaming - Blitzoo'
      },
      component: ResponsibleGaming
    },
    {
      path: '*',
      redirect: { name: 'home' }
    }
  ]
})
